var Circle = /** @class */ (function () {
    function Circle(position, r, color, name) {
        this.position = position;
        this.r = r;
        this.color = color || '#000000';
        this.name = name || 'A';
        this.styles = { size: r, color: this.color };
    }
    Circle.prototype.update = function (mousePos) {
        var isOver = this.distance(mousePos) < this.r;
        if (isOver && this.onMouseOver) {
            var styles = this.onMouseOver();
            if (styles.color)
                this.color = styles.color;
            if (styles.size && this.r === this.styles.size)
                this.r = this.r * styles.size;
        }
        else if (!isOver) {
            this.color = this.styles.color;
            this.r = this.styles.size;
        }
    };
    Circle.prototype.distance = function (v) {
        return this.position.subtract(v).abs();
    };
    Circle.prototype.drawCanvas = function (ctx) {
        ctx.beginPath();
        ctx.arc(this.position.x, this.position.y, this.r, 0, 2 * Math.PI);
        ctx.fillStyle = this.color;
        ctx.fill();
        ctx.closePath();
    };
    return Circle;
}());
export default Circle;
//# sourceMappingURL=circle.js.map